(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '../header-translations', './Search', './MobileSearch', './Grip', './Drawer', '../Link', 'prop-types', './SiteSelector'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('../header-translations'), require('./Search'), require('./MobileSearch'), require('./Grip'), require('./Drawer'), require('../Link'), require('prop-types'), require('./SiteSelector'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.headerTranslations, global.Search, global.MobileSearch, global.Grip, global.Drawer, global.Link, global.propTypes, global.SiteSelector);
    global.Header = mod.exports;
  }
})(this, function (exports, _react, _headerTranslations, _Search, _MobileSearch, _Grip, _Drawer, _Link, _propTypes, _SiteSelector) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _headerTranslations2 = _interopRequireDefault(_headerTranslations);

  var _Search2 = _interopRequireDefault(_Search);

  var _MobileSearch2 = _interopRequireDefault(_MobileSearch);

  var _Grip2 = _interopRequireDefault(_Grip);

  var _Drawer2 = _interopRequireDefault(_Drawer);

  var _Link2 = _interopRequireDefault(_Link);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _SiteSelector2 = _interopRequireDefault(_SiteSelector);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var ANIMTIME = 0.3;
  /**
   * Class container of entire Header.
   */

  var Header = function (_React$Component) {
    _inherits(Header, _React$Component);

    function Header(props) {
      _classCallCheck(this, Header);

      var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

      _this.state = {
        open: false,
        searchOpen: false,
        hidden: false,
        scrollStart: 0,
        buttonWidth: 0,
        minWidth: 0,
        scrollPosition: 0,
        overflowAnim: true,
        left: 0,
        isMobile: false,
        // use base tranlastions and override with Drupal Menu API
        translations: _this.props.drupalData || _headerTranslations2.default[_this.props.lang]
      };
      _this.minWdith = 0;
      _this.globalClose = _this.handleClose.bind(_this);
      _this.throttleResize = _this.resize.bind(_this);
      _this.handleEscKey = _this.handleEscEvent.bind(_this);
      _this.toggleMenuEvent = _this.toggleMenu.bind(_this);
      _this.handleScrolling = _this.handleScroll.bind(_this);
      return _this;
    }

    _createClass(Header, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('scroll', this.handleScrolling);

        // Add varible to track that it's mobile
        this.setState({
          isMobile: window.innerWidth < 1200
        });

        window.addEventListener('resize', this.throttleResize);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        // Remove the event with 'this' bound
        window.removeEventListener('scroll', this.handleScrolling);
        window.removeEventListener('resize', this.throttleResize);
        window.removeEventListener('keydown', this.handleEscKey);
      }
    }, {
      key: 'useHtml',
      value: function useHtml(html) {
        return { __html: html };
      }
    }, {
      key: 'handleEscEvent',
      value: function handleEscEvent(e) {
        if (e.keyCode === 27) {
          this.toggleMenu();
        }
      }
    }, {
      key: 'resize',
      value: function resize() {
        var _this2 = this;

        clearTimeout(this.resizeReady);
        this.resizeReady = setTimeout(function () {
          _this2.setState({
            isMobile: window.innerWidth < 1200
          });

          if (!_this2.props.isMobile) {
            _this2.setState({
              open: false
            });
          }
        }, 50);
      }
    }, {
      key: 'handleBubble',
      value: function handleBubble(e) {
        e.stopPropagation();
      }
    }, {
      key: 'handleClose',
      value: function handleClose(e) {
        this.toggleMenu();
      }
    }, {
      key: 'scrollMove',
      value: function scrollMove(e) {
        this.setState({
          scrollTime: setTimeout(function () {
            var delta = this.state.scrollPosition - this.state.scrollStart;
            var update = {
              scrollPosition: 0,
              scrollStart: 0
            };

            if (delta > 50) {
              update.hidden = true;
              update.overflowAnim = false;
            } else if (delta < -20) {
              update.hidden = false;

              setTimeout(function () {
                this.setState({
                  overflowAnim: true
                });
              }.bind(this), ANIMTIME * 1000);
            }

            this.setState(update);
          }.bind(this), 200)
        });
      }
    }, {
      key: 'handleScroll',
      value: function handleScroll(e) {
        if (this.state.open) {
          return;
        }

        if (this.state.scrollPosition === 0) {
          this.scrollMove();
          this.setState({
            scrollPosition: window.scrollY,
            scrollStart: window.scrollY
          });
        } else {
          this.setState({
            scrollPosition: window.scrollY
          });
        }
      }
    }, {
      key: 'toggleMenu',
      value: function toggleMenu() {
        this.setState({
          open: !this.state.open
        });
      }
    }, {
      key: 'toggleSearch',
      value: function toggleSearch() {
        this.setState({
          searchOpen: !this.state.searchOpen
        });
      }
    }, {
      key: 'getClassStyle',
      value: function getClassStyle(classes, secondToLast) {
        if (!classes) {
          return secondToLast ? '#f0ab00' : '#008FD3';
        }

        var colorList = [{
          class: 'gold',
          color: '#fff'
        }, {
          class: 'concur-blue',
          color: '#008FD3'
        }, {
          class: 'white',
          color: '#fff'
        }];

        return colorList.find(function (color) {
          return classes.match(color.class);
        }).color;
      }
    }, {
      key: 'renderButtons',
      value: function renderButtons() {
        return this.state.translations.mainBtn.map(function (btn, key) {
          var secondToLast = key === this.state.translations.mainBtn.length - 2;
          var color = this.getClassStyle(btn.classes, secondToLast);
          // const excludeCE = btn.text === this.state.translations.loginLink.text ? ' -ce-ignore' : '';
          if (!btn.link) {
            return _react2.default.createElement(
              'span',
              {
                key: key,
                style: {
                  margin: '15px 5px',
                  float: 'left',
                  textDecoration: 'none'
                },
                className: btn.classes || 'hidden-xs'
              },
              btn.text
            );
          }

          return _react2.default.createElement(
            _Link2.default,
            {
              key: key,
              href: btn.link
              // rel={btn.text === this.state.translations.loginLink.text ? 'nofollow' : ''}
              , style: {
                float: 'left',
                padding: '12px 16px',
                fontSize: '14px',
                lineHeight: '15px',
                borderColor: color,
                color: color,
                borderWidth: '1px',
                borderStyle: 'solid',
                borderRadius: '1px',
                fontWeight: '300',
                textDecoration: 'none',
                transition: 'all 0.25s ease-in-out'
              },
              hoverStyles: {
                backgroundColor: color,
                borderColor: color,
                color: color === '#fff' ? '#000' : '#fff'
              }
              // className={btn.classes + excludeCE || ('btn-ghost hidden-xs' + excludeCE + (secondToLast ? ' gold' : ' concur-blue'))}
              , className: btn.classes || 'btn-ghost hidden-xs' + (secondToLast ? ' gold' : ' concur-blue')
            },
            btn.text
          );
        }.bind(this));
      }
    }, {
      key: 'getPageHeight',
      value: function getPageHeight() {
        if (typeof document === 'undefined') return 0;

        var body = document.body;
        var html = document.documentElement;
        return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight) - 75;
      }
    }, {
      key: 'render',
      value: function render() {
        var stickyMenuStyles = {
          width: '100%',
          position: 'fixed',
          backgroundColor: '#000',
          color: '#fff',
          // transition: `all ${ANIMTIME}s ease-in-out`,
          zIndex: 3
        };
        var drawerContainer = {
          position: 'absolute',
          right: 0,
          left: 0
        };

        drawerContainer.height = this.state.isMobile && this.state.open ? '100%' : 'auto';

        return _react2.default.createElement(
          'div',
          {
            className: 'www-header-com',
            style: {
              height: '75px'
            }
          },
          _react2.default.createElement('div', { id: 'consent_blackbar' }),
          _react2.default.createElement(
            'div',
            {
              className: 'sticky-menu',
              style: stickyMenuStyles
            },
            _react2.default.createElement(
              'div',
              { className: 'container', style: {
                  paddingRight: '14px',
                  paddingLeft: '14px'
                } },
              _react2.default.createElement(
                'div',
                {
                  className: 'col-sm-12',
                  onClick: this.state.open ? this.handleBubble : false
                },
                _react2.default.createElement(
                  'a',
                  {
                    style: {
                      position: 'relative',
                      zIndex: '40',
                      lineHeight: '54px'
                    },
                    className: 'pull-left',
                    title: 'SAP Concur',
                    href: this.state.translations.logo.href || '/'
                  },
                  _react2.default.createElement('div', {
                    style: {
                      background: 'url(sites/all/modules/custom_concur/concur_responsive_menu/images/sap-concur.svg) no-repeat',
                      width: '165px',
                      height: '36px',
                      position: 'relative',
                      top: '20px',
                      marginTop: '0',
                      marginRight: '20px'
                    }
                  })
                ),
                _react2.default.createElement(_Drawer2.default, {
                  open: this.state.open,
                  siteLinks: this.state.translations.siteLinks,
                  supportLinks: this.state.translations.supportLinks,
                  mobileAppText: this.state.translations.mobileAppText,
                  socialLinks: this.state.translations.socialLinks,
                  handleBubble: this.handleBubble,
                  isMobile: this.state.isMobile
                  // loginLink={this.state.translations.loginLink}
                }),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'col-lg-4 col-md-6 col-sm-8 pull-right flush-right cta-wrap',
                    style: {
                      height: '75px',
                      padding: 0,
                      width: 'auto'
                    }
                  },
                  _react2.default.createElement(_Grip2.default, {
                    toggleMenu: this.toggleMenuEvent,
                    open: this.state.open,
                    dropdownLabel: this.state.translations.menuToggle && this.state.translations.menuToggle.label
                  }),
                  _react2.default.createElement(_SiteSelector2.default, {
                    lang: this.props.lang,
                    isMobile: this.state.isMobile
                  }),
                  _react2.default.createElement(_Search2.default, {
                    hasSearch: !!this.state.translations.search,
                    placeholder: this.state.translations.search && this.state.translations.search.placeholder,
                    searchOpen: this.state.searchOpen,
                    open: this.state.open,
                    toggleSearch: this.toggleSearch.bind(this),
                    isMobile: this.state.isMobile,
                    minWidth: this.state.minWidth
                  }),
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'pull-right cta-button-container hidden-xs',
                      style: {
                        display: 'inline',
                        position: 'relative',
                        top: '18px',
                        paddingRight: '4px',
                        left: '-2px'
                      }
                    },
                    this.renderButtons()
                  )
                )
              ),
              _react2.default.createElement(_MobileSearch2.default, {
                hasSearch: !!this.state.translations.search,
                placeholder: this.state.translations.search && this.state.translations.search.placeholder,
                searchOpen: this.state.searchOpen,
                isMobile: this.state.isMobile,
                open: this.state.open
              })
            )
          )
        );
      }
    }]);

    return Header;
  }(_react2.default.Component);

  exports.default = Header;
  ;

  Header.propTypes = {
    lang: _propTypes2.default.string,
    open: _propTypes2.default.bool,
    drupalData: _propTypes2.default.object,
    isMobile: _propTypes2.default.bool
  };

  Header.defaultProps = {
    lang: 'en-us',
    open: false
  };
});